<template lang="pug">
  include /mixins
  +b.result-wrapper
    ui-loader(v-if="isLoad")
    div(v-else-if="items.length")
      +b.section-title.H2 {{ _("Результати процедури") }}
      +b.slider-box--free.relative.js-ajax-slider-box
        +b.category-swipe-wrapper.--variant_common.fake-slider
          +e.cell.--variant_3(v-for="item in items")
            modal-trigger(
              url='Result/Detail'
              :classes='["result-details-modal"]'
              :item="item"
            )
              template(#default="{ open }")
                +b.t-result-card
                  +e.preview-wrapper(@click.prevent="open")
                    template(v-if="item.props.video")
                      +e.IMG.play-icon(:src="'/static/img/play.svg'")
                      +e.PICTURE.image-wrapper
                        +e.image.IMG(
                          v-if="item.props.video.img"
                          :src="item.props.video.img"
                        )
                        +e.placeholder.IMG(
                          v-else
                          :src="'/static/img/academy_placeholder.png'"
                        )
                    template(v-else)
                      template(v-for="image_item in item.props.images")
                        +e.IMG.icon(:src="'/static/img/zoom-white.svg'")
                        +e.PICTURE.image-wrapper(
                          :class="[{ 'is-vertical': item.props.result_layout_type === 'vertical' }, { 'is-horizontal': item.props.result_layout_type == 'horizontal' }]"
                        )
                          source(
                            type="image/webp",
                            :srcset="image_item.props.img.preview_webp"
                          )
                          +e.IMG.image(
                            :src="image_item.props.img.preview"
                          )
                  +e.content
                    +b.g-row.--align_center.--justify_between
                      +b.g-cell
                        result-rating(
                          v-if="isAuth"
                          :item_id="item.props.id"
                          :item_type="item.props._type"
                          :rating="item.props.object_rating || ''"
                          :user_name="userName"
                          :user_email="userEmail"
                        )
                      +b.g-cell
                        +b.SPAN.tt-link.--size_sm.--size_md-xl.--accent.--weight_semibold.--inline(
                          @click.prevent="open"
                        ) {{ _("Детали процедуры") }}

        +b.ds-panel.--space_xl.--space_3xl-xl
          +e.element.--offset_top
            +b.g-row.--align_center.--justify_between
              +b.g-cell
                +b.t-controls.--variant_results.snap-controls(
                  :data-count="items.length"
                )
                  +e.item.is-disabled(
                    data-snap-slider-goto="right" :aria-label="_('Следующий слайд')"
                  )
                    +b.mdi.mdi-chevron-left
                  +e.item(
                    data-snap-slider-goto="left" :aria-label="_('Предыдущий слайд')"
                  )
                    +b.mdi.mdi-chevron-right
              +b.g-cell
                result-create-button(
                  :id="objectId"
                  :is-equipment="isEquipment"
                )
    div(v-else)
      +b.section-title.--variant_centered.H2 {{ _("Результати процедури") }}
      +b.ds-panel.--space_md.--space_xl-xl
        +e.element.--offset_bottom
          +b.ds-caption--size_sm--size_md-xl.--semibold.--appearance_center.P {{ _('Результаты пока не добавлены. Будь первым') }}
      +b.g-row.--justify_center
        +b.g-cell
          result-create-button(
            :id="objectId"
            :is-equipment="isEquipment"
          )
</template>

<script>
import sliderControl from '@utils/slider-controls'
import { productResultListResource } from '@api/catalog.service'

const RESULT_TYPE_BEFORE = 'before'

export default {
  props: {
    objectId: {
      type: String,
    },
    isEquipment: {
      type: Boolean,
    },
  },

  data() {
    return {
      isLoad: false,
      items: [],
      isAuth: window.authent,
      userName: window.request_name,
      userEmail: window.request_email,
    }
  },

  async created() {
    this.isLoad = true

    await this.getData()

    await this.$nextTick()

    sliderControl('js-ajax-slider-box')

    this.isLoad = false
  },

  methods: {
    prepareItems(arr) {
      return arr.map(el => {
        el.props.images = el.props.product_result_images || el.props.equipment_result_images

        el.props.images.sort((a, b) => {
          if (a.props.type === RESULT_TYPE_BEFORE) return -1
          if (b.props.type === RESULT_TYPE_BEFORE) return 1
          return 0
        })

        return el
      })
    },

    async getData() {
      const params = { id: this.objectId, limit: 50 }

      const { data } = await productResultListResource.execute(params)

      this.items = this.prepareItems(data.items)
    },
  },
}
</script>
